import React from 'react';
import PropTypes from 'prop-types';
import { MapPosition } from '../../../utils/prop-types/common-types';
import StationPropType from '../../../utils/prop-types/station';

import styles from './styles.css';

// Google Map uses "position" prop for showing the marker. So, although not used in this component, kept here
// eslint-disable-next-line no-unused-vars
const StationMapInfoBox = ({ position, station, borderColor, headerColor = borderColor, title, logoSize }) => {
  let fuelLogo = station.brandings.fuel_brand_logo_url;
  let isFuelBrand = fuelLogo !== '';
  const isStoreBrand = station.brandings.cstore_brand_logo_url !== '';

  if (!isFuelBrand && !isStoreBrand) {
    // non-branded
    fuelLogo = 'https://images.gasbuddy.io/b/0.png';
    isFuelBrand = true;
  }

  return (
    <div
      className={`${styles.infoBoxContainer} ${borderColor ? styles.borderedInfoBox : ''}`}
      style={borderColor ? { border: `solid 2px ${borderColor}`, borderRadius: '8px' } : null}
    >
      <div
        className={styles.header}
        style={headerColor ? { backgroundColor: headerColor } : null}
      >
        {title}
      </div>
      <div className={styles.detail}>

        {(isFuelBrand) && (
          <div>
            <img src={fuelLogo} alt="" className={(logoSize && logoSize === 'sm') ? styles.smallBrandLogo : ''} />
          </div>
        )}

        {(isStoreBrand && (station.brandings.cstore_brand_logo_url !== station.brandings.fuel_brand_logo_url)) && (
          <div>
            <img src={station.brandings.cstore_brand_logo_url} alt="" className={(logoSize && logoSize === 'sm') ? styles.smallBrandLogo : ''} />
          </div>
        )}
        <div className="clearfix" />
      </div>
    </div>
  );
};

StationMapInfoBox.propTypes = {
  position: MapPosition.isRequired,
  station: StationPropType.isRequired,
  borderColor: PropTypes.string,
  headerColor: PropTypes.string,
  title: PropTypes.string.isRequired,
  logoSize: PropTypes.string,
};

StationMapInfoBox.defaultProps = {
  borderColor: undefined,
  headerColor: undefined,
  logoSize: undefined,
};

module.exports = StationMapInfoBox;
